var _defs, _rect, _rect2, _rect3, _g, _g2, _rect4, _text, _rect5, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompressorRecip3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steel",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c6cfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "steelDark",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4a545c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c333a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a201b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copper",
    x1: 0,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6c79b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d9853f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96501a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copperEdge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b06428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3c295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d4a16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brass",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0dfa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c8a83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d7420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lcd",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fb37c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shellWhite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eef1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfdfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9efe6"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 36,
    height: 36,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 0 L 0 0 0 36",
    fill: "none",
    stroke: "#628141",
    strokeOpacity: 0.13,
    strokeWidth: 1.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 816,
    height: 816,
    fill: "none",
    stroke: "#628141",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 460) scale(0.76)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 150,
    rx: 200,
    ry: 54,
    fill: "#0f1512",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-196,150 L-196,-10 a196,140 0 0 1 392,0 L196,150 a30,26 0 0 1 -30,26 L-166,176 a30,26 0 0 1 -30,-26 Z",
    fill: "url(#steelDark)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-196,-10 a196,140 0 0 1 392,0 Z",
    fill: "#ffffff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: -186,
    y: 30,
    width: 140,
    height: 120,
    fill: "#ffffff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: -56,
    y: -190,
    width: 112,
    height: 70,
    rx: 18,
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -26,
    cy: -154,
    r: 12,
    fill: "#20261f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -154,
    r: 12,
    fill: "#20261f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: -154,
    r: 12,
    fill: "#20261f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-150,-96 C-206,-96 -230,-144 -206,-176",
    fill: "none",
    stroke: "url(#copperEdge)",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,-96 C206,-96 230,-144 206,-176",
    fill: "none",
    stroke: "url(#copperEdge)",
    strokeWidth: 18,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -236,
    y: 150,
    width: 90,
    height: 34,
    rx: 14,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 150,
    width: 90,
    height: 34,
    rx: 14,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 96,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 0.35,
    textAnchor: "middle",
    letterSpacing: 1.56
  }, "RECIPROCATING"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#628141",
    strokeWidth: 2,
    strokeOpacity: 0.7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 732 h560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 722 v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 722 v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 220 v420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 220 h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 640 h20"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 716,
    width: 140,
    height: 32,
    rx: 6,
    fill: "#fbfdfa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 739,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#628141",
    fillOpacity: 1,
    textAnchor: "middle",
    letterSpacing: 1.6
  }, "0.5\u20135 TR")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 112,
    height: 40,
    fill: "#1B211A"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 69,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 19,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 2.28
  }, "Godrej")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 854,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#1B211A",
    fillOpacity: 0.5,
    textAnchor: "start",
    letterSpacing: 0.96
  }, "Reciprocating Compressor \u2014 TECHNICAL VIEW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressorRecip3);
export default __webpack_public_path__ + "static/media/compressor-recip-3.686e15a2294e16462342f20f24ea57d7.svg";
export { ForwardRef as ReactComponent };